import { Checkbox, FormControlLabel } from '@mui/material';
import { styled } from '@mui/material/styles';

const StyledCheckbox = styled(Checkbox)(({ theme }) => ({
  padding: '8px',

  '& .MuiSvgIcon-root': {
    fontSize: '1.6rem',
    color: 'transparent',
    border: `2px solid ${theme.palette.primary.main}`,
    borderRadius: '4px',
    backgroundColor: 'transparent',
  },

  '&:hover': {
    backgroundColor: 'rgba(94, 137, 79, 0.04)',
  },

  '&.Mui-checked': {
    '& .MuiSvgIcon-root': {
      color: 'white',
      backgroundColor: theme.palette.primary.main,
      border: `0px solid ${theme.palette.primary.main}`,
    },

    '&:hover': {
      backgroundColor: 'rgba(94, 137, 79, 0.08)',
    },
  },

  '&.Mui-focusVisible': {
    outline: `1px solid ${theme.palette.primary.main}`,
    outlineOffset: '1px',
  },

  '& .MuiCheckbox-root': {
    color: 'transparent',
  },
}));

const StyledFormControlLabel = styled(FormControlLabel)(({ theme }) => ({
  marginLeft: 0,
  marginRight: 0,

  '& .MuiFormControlLabel-label': {
    fontSize: { xs: '14px', sm: '16px' },
    fontWeight: 'medium',
    color: theme.palette.text.primary,
    userSelect: 'none',
    marginLeft: '8px',
  },

  '&:hover .MuiFormControlLabel-label': {
    color: theme.palette.primary.main,
  },
}));

const CustomCheckbox = ({
  checked,
  onChange,
  name,
  label,
  disabled = false,
  size = 'medium',
  sx = {},
  labelSx = {},
  ...props
}) => {
  if (label) {
    return (
      <StyledFormControlLabel
        control={
          <StyledCheckbox
            checked={checked}
            onChange={onChange}
            name={name}
            disabled={disabled}
            size={size}
            {...props}
          />
        }
        label={label}
        sx={{
          '& .MuiFormControlLabel-label': {
            ...labelSx,
          },
          ...sx,
        }}
      />
    );
  }

  return (
    <StyledCheckbox
      checked={checked}
      onChange={onChange}
      name={name}
      disabled={disabled}
      size={size}
      sx={sx}
      {...props}
    />
  );
};

export default CustomCheckbox;
